import PermissionRole from './PermissionRole';
import RawDataExport from './RawDataExport';
import { IUser, IPermissionFilter } from '../../types/types';

import { graphQLPost } from '../../utilities';

export default class Administration {
    static async getUsers(): Promise<IUser[]> {
        try {
            const response = await graphQLPost('{ users { id userName email } }');
            
            return response.users as IUser[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av användare...");
        }
    }

    static async getFilters(): Promise<IPermissionFilter[]> {
        try {
            const response = await graphQLPost('{ filters { displayName fieldName query queryName } }');
            
            return response.filters as IPermissionFilter[];
        }
        catch(e) {
            console.error(e);
            throw("Fel vid begäran av filter...");
        }
    }

    static PermissionRole = PermissionRole;
    static RawDataExport = RawDataExport;
}